<div class="wrapper">
  <div class="content-wrapper">
    <div class="mobile-screen">
      <div class="br-section-wrapper-take-order" *ngIf="takeOrderActive">
        <div class="beta-version"><b>Beta version!!</b>
          <div class="beta-description">For Testing purpose only</div>
        </div>
        <!-- <app-ce-calendar></app-ce-calendar> -->
        <div class="row">
          <div class="col-12 text-center user-container">
            <h7 class="user-name">{{user?.user?.firstName}} {{user?.user?.lastName}}</h7>
            </div>
          <div class="input-container col-12" style="padding-left: 15px; margin-top: 20px;">
            <h7><b>Carrier</b></h7>
            <ng-select [(ngModel)]="selectedTenant" [virtualScroll]="true" class="custom"
              (ngModelChange)="changeTenantFilter();displayCount();" placeholder="Start typing to search carrier"
              (click)="checkTenantFiltersAvailability()">
              <ng-option *ngFor="let tenant of tenants; let tenantIndex = index" [value]="tenant">
                {{tenant?.tenantDTO?.tenantDescription}}</ng-option>
            </ng-select>
          </div>

          <div class="input-container col-12" style="padding-left: 15px; margin-top: 20px;">
            <h7><b>Delivery Site</b></h7>
            <ng-select [(ngModel)]="selectedDealer" [virtualScroll]="true" class="custom"
              (ngModelChange)="displayCount(selectedDealer); allowOrderSelection = false; takeOrder()"
              placeholder="Start typing to search dealer..." (click)="checkTenantFiltersAvailability()">
              <ng-option *ngFor="let dealer of dealers; let dealerIndex = index" [value]="dealer">
                {{dealer?.dealer}} | {{dealer?.address}}</ng-option>
            </ng-select>
          </div>
        </div>
        <!-- <div class="col-12 text-center" *ngIf="selectedDealer">
        <button class="take-order-button" (click)="takeOrderActive = true; takeOrder()">Take Order</button>
      </div> -->
      </div>

      <div
        [ngClass]="{'br-section-wrapper-take-order-active': allowOrderSelection && selectedDealer, 'br-section-wrapper-take-order-inactive': (!allowOrderSelection || !selectedDealer)}">
        <div class="row">
          <div class="col-6">Location Id : {{selectedDealerFromBackend?.locationID}}</div>
          <div class="col-6">Dealer : {{selectedDealerFromBackend?.billtype?.billingCodeName}}</div>

          <div class="col-6">TAC : {{selectedDealerFromBackend?.tac}}</div>
          <div class="col-6">TAC : {{selectedDealerFromBackend?.address}}</div>
          <div class="col-6">CO Billtype : {{selectedDealerFromBackend?.billtype?.billingCodeName}}</div>

          <div class="col-6">City : {{selectedDealerFromBackend?.city}}</div>
          <div class="col-6">State : {{selectedDealerFromBackend?.state}}</div>
          <div class="col-6">Zip : {{selectedDealerFromBackend?.zip}}</div>
        </div>

        
        <div class="row">
          <div class="col-12">
            Delivery Window start:
            <div>
              <div class="input-group">
                <label style="margin-left: -2%;">
                  <!-- <input [owlDateTimeTrigger]="dt12" [owlDateTime]="dt12" placeholder="yyyy-MM-dd HH:mm:ss"
                    [(ngModel)]="takeOrderModel.deliveryTimeStart" (ngModelChange)="selectDeliveryDate()"
                    [selectMode]="'rangeFrom'" class="dateTimeSelector" [min]="minFrom" [max]="maxFrom" />
                  <owl-date-time #dt12></owl-date-time> -->
                  <!-- <span class="trigger" [owlDateTimeTrigger]="dt12">
                    <i class="fa fa-calendar calendar-selector"></i>
                  </span> -->
                  <input placeholder="yyyy-MM-dd HH:mm:ss"
                    [(ngModel)]="deliveryTimeStartFormatted"
                    class="dateTimeSelector" [min]="minFrom" [max]="maxFrom"  readonly="readonly" (click)="selectDeliveryStartTime = true"/>
                </label>
                <span (click)="selectDeliveryStartTime = true" readonly="readonly">
                  <i class="fa fa-calendar calendar-selector"></i>
                </span>
                <app-ce-datetime-picker [label]="'Delivery Start Time'" [showPanel]="selectDeliveryStartTime" 
                [date]="takeOrderModel.deliveryTimeStart" (showPanelChange)="selectDeliveryStartTime = $event"
                (dateChange)="changeStartTime($event)"></app-ce-datetime-picker>
              </div>
            </div>
          </div>
          <div class="col-12">
            Delivery Window end:
            <div>
              <div class="input-group">
                <label style="margin-left: -2%;">
                  <!-- <input [owlDateTimeTrigger]="dt13" [owlDateTime]="dt13" placeholder="yyyy-MM-dd HH:mm:ss"
                    [disabled]="!takeOrderModel?.deliveryTimeStart" [(ngModel)]="takeOrderModel.deliveryTimeStart"
                    [selectMode]="'rangeTo'" class="dateTimeSelector" [min]="minTo" [max]="maxTo" />
                  <owl-date-time #dt13></owl-date-time>
                  <span class="trigger" [owlDateTimeTrigger]="dt13" [disabled]="!takeOrderModel?.deliveryTimeStart">
                    <i class="fa fa-calendar calendar-selector"></i>
                  </span> -->

                  <input placeholder="yyyy-MM-dd HH:mm:ss"
                    [disabled]="!takeOrderModel?.deliveryTimeStart" [(ngModel)]="deliveryTimeEndFormatted"
                    class="dateTimeSelector" [min]="minTo" [max]="maxTo" readonly="readonly" (click)="selectDeliveryEndTime = true" />
                </label>

                <span (click)="selectDeliveryEndTime = true" readonly="readonly">
                  <i class="fa fa-calendar calendar-selector"></i>
                </span>

              <app-ce-datetime-picker [label]="'Delivery End Time'" [showPanel]="selectDeliveryEndTime" 
              [date]="takeOrderModel.deliveryTimeEnd" (showPanelChange)="selectDeliveryEndTime = $event"
              (dateChange)="changeEndTime($event)"></app-ce-datetime-picker>
              </div>
            </div>
          </div>
          <!-- <div class="col-12">
            <div>Schedule Date</div>
            <div>
              <div class="input-group">
                <label style="margin-left: -2%;">
                  <input [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" class="take-order-input"
                    [(ngModel)]="takeOrderModel.deliveryDate" [ngModelOptions]="{standalone: true}"
                    class="dateTimeSelector" placeholder="yyyy-MM-dd 00:00:00" disabled>
                  <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                  <span class="trigger" [owlDateTimeTrigger]="dt3">
                    <i class="fa fa-calendar calendar-selector"></i>
                  </span>
                </label>
              </div>
            </div>
          </div> -->
        </div>

        <div class="row">
          <div class="col-6">
            Order No:
            <div><input type="text" class="take-order-input" [(ngModel)]="takeOrderModel.salesOrderNumber"></div>
          </div>
          <div class="col-6">
            Po No:
            <div><input type="text" class="take-order-input" [(ngModel)]="takeOrderModel.customerPO"></div>
          </div>

        </div>
        
        <div class="row">
          <!-- <div class=" col-12">
            Loading Notes:
            <div>
              <textarea class="take-order-textarea" rows="3" [(ngModel)]="takeOrderModel.loadingNotes"></textarea>
            </div>
          </div> -->

          <div class=" col-12">
            Notes:
            <div>
              <textarea class="take-order-textarea" rows="3" [(ngModel)]="takeOrderModel.notes"></textarea>
            </div>
          </div>
          <!-- <div class="col-6">
          Notes for Dispatcher:
          <div>
            <textarea class="take-order-textarea" rows="3" [(ngModel)]="takeOrderModel.dispatchNotes"></textarea>
          </div>
        </div> -->
        </div>



        <div class="row product-padding">
          <div class="row text-center" *ngIf="(!products || products.length ==0) && allowOrderSelection">
            <div class="col-12 text-center">
              <img src="assets/images/ajax-loader.gif" /> Fetching products
            </div>
          </div>
          <div class="row  product-element " [ngClass]="product?.class" *ngFor="let product of products">
            <div class="col-6 text-center"><div class="text-center product-name-label" *ngIf="product?.productName">{{product?.productName}}</div>
              <ng-select [(ngModel)]="newProductAdded" [virtualScroll]="true" class="custom text-left"
                *ngIf="!product?.productName" (ngModelChange)="addProduct(product, newProductAdded)"
                placeholder="Product" (click)="checkTenantFiltersAvailability()"
                style="margin-top: -8px">
                <ng-option *ngFor="let newProduct of productList; let productIndex = index" [value]="newProduct">
                  {{newProduct?.productName}}</ng-option>
              </ng-select>
            </div>
            <div class="col-6 "><input type="number" class="take-order-input" placeholder="Quantity" [(ngModel)]="product.quantity"></div>
            <!-- <div class="col-2 ">{{product?.tankName? product?.tankName : "Not Available"}}</div> -->
            <div class="col-12 ">
              <ng-select [(ngModel)]="product.terminalSupplierMapping" [virtualScroll]="true" class="custom"
                (ngModelChange)="displayCount(product.terminalSupplierMapping);" placeholder="Terminal : TBD"
                (click)="checkTenantFiltersAvailability()">
                <ng-option value="undefined" [disabled]="true">Terminal</ng-option>
                <ng-option *ngFor="let terminalSupplierMapping of terminalSuppliersMapping | keyvalue"
                  [value]="terminalSupplierMapping.value">
                  {{terminalSupplierMapping?.key}}</ng-option>
              </ng-select>
            </div>
            <div class="col-12 ">
              <ng-select [(ngModel)]="product.tblLoadUnder" [virtualScroll]="true" class="custom"
                [disabled]="!product?.terminalSupplierMapping" (ngModelChange)="displayCount(product.tblLoadUnder);"
                placeholder="Supplier : TBD" (click)="checkTenantFiltersAvailability()">
                <ng-option value="undefined"  [disabled]="true">Supplier</ng-option>
                <ng-option *ngFor="let tblLoadUnder of product?.terminalSupplierMapping?.tblLoadUnders"
                  [value]="tblLoadUnder">
                  {{tblLoadUnder?.loadUnderName}}</ng-option>
              </ng-select>
            </div>
            <div class="col-12 text-right">
              <button class="remove-product-button" (click)="removeProduct(product)">
                <i class="fa fa-trash"></i>
              </button>
            </div>
            <div class="col-12">
              <hr class="new4" />
            </div>
          </div>

          <div class="row" style="margin-bottom: 20px;width: 113%;">
            <div class="col-12">
              <button class="add-product-button" (click)="addProduct()">
                <i class="fa fa-plus"></i> Add Products
              </button>
            </div>
          </div>

          <div class="row" style="margin-bottom: 20px;width: 113%;">
            <div class="col-12">
              <button class="add-product-button" (click)="captureOrder();">Place Order
              </button>
            </div>
          </div>

        </div>


        <!-- <div class="row">
          <div class="col-md-4 col-12">
            <button class="take-order" (click)="captureOrder();">Place Order</button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>

<!-- Create a modal to display that the order has been placed successfully-->
 <!-- modal -->
<ng-template #successModal let-c="close" let-d="dismiss">
  <div class="modal-header" style="background-color: #4c6e9e; color: #ffffff;">
    <h5 class="modal-title" style="font-size: 15px;">Load Details</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true" style="color: white">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!--Order placed successfully including tick graphics and slight animation-->
    <div class="row">
      <div class="col-12 text-center">
        <i class="fa fa-check-circle" style="font-size: 100px; color: #4c6e9e;"></i>
      </div>
      <div class="col-12 text-center">
        <h7>Order placed successfully</h7>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary close-modal" (click)="c('Close click')">Close</button>
  </div>
</ng-template>